import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemService } from '../services/system.service';

@Injectable({
  providedIn: 'root'
})
export class KpiService {

  constructor(private http: HttpClient, private system: SystemService) { }

  getKpiIndicators(params?: any): Observable<any[]> {
    let httpParams = new HttpParams();

    if (params?.startDate) {
      httpParams = httpParams.set("startDate", params.startDate);
    }
    if (params?.endDate) {
      httpParams = httpParams.set("endDate", params.endDate);
    }

    return this.http.get<any[]>(this.system.apiURL + "/kpi/indicators", { params: httpParams });
  }

  getMainKpis(params?: any): Observable<any[]> {
    let httpParams = new HttpParams();

    if (params?.startDate) {
      httpParams = httpParams.set("startDate", params.startDate);
    }
    if (params?.endDate) {
      httpParams = httpParams.set("endDate", params.endDate);
    }

    return this.http.get<any[]>(this.system.apiURL + "/kpi/main", { params: httpParams });
  }

  getRecruitmentKpis(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/kpi/recruitments");
  }

  getEmployeeKpis(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/kpi/employees");
  }

  getContactKpis(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/kpi/contracts");
  }

  getTrainingKpis(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/kpi/trainings");
  }

  getAssessmentKpis(): Observable<any[]> {
    return this.http.get<any[]>(this.system.apiURL + "/kpi/assessments");
  }
}
